import axios from "axios";

axios.defaults.timeout = 30_000;

/** Axios instance without any interceptors */
export const uninterceptedAxiosInstance = axios.create();
